export default __webpack_public_path__ + "static/TrustAlice-Background-e1d5f100fd06143ee10f7745b5496716.jpg";